import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators, UntypedFormGroup, UntypedFormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { ChangePasswordService } from '../../../change-password/change-password.service';
import { ResetPasswordModel } from '../../../change-password/reset-password-model';


@Component({
  standalone: false,
  selector: 'ngb-initial-password-reset-modal-content',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{title}}</h4>
      //<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross')">
      //  <span aria-hidden="true">&times;</span>
      //</button>
    </div>
    <div class="modal-body">
     <form novalidate [formGroup]="editForm">
      <div class="col-md-6 offset-md-3" style="width: 100%;">    
        <div style="margin:25px auto;">            
          <div class="form-group">
            <label for="proposedPassword">New Password</label>
            <input type="password" class="k-textbox" style="width:100%;" formControlName="proposedPassword" />
          </div>
          <div class="form-group">
            <label for="confirmPassword">New Password</label>
            <input type="password" class="k-textbox" style="width:100%;" formControlName="confirmPassword" />
          </div>
          <div *ngIf="(editForm.controls.confirmPassword.errors || editForm.errors?.mismatch) && (editForm.controls.confirmPassword.dirty || editForm.controls.confirmPassword.touched)"
                class="form-control-feedback">
            <span *ngIf="editForm.controls.confirmPassword.errors || editForm.errors?.mismatch" style="color: red;">
              Passwords must match
            </span>
          </div>     
            <div class="row" style="display:flex; justify-content:center;">
              <div>
                <input type="button" class="btn btn-primary" value="Change Password" [disabled]='!editForm.valid' (click)="changeInitialPassword()">
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      //<button type="button" class="btn btn-primary" [disabled]="true" (click)="activeModal.close('Agree')">I Agree</button>
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Cancel')">Cancel</button>
    </div>  `
})
export class NgbInitialPasswordResetModalContent implements OnInit {
  @Input() title;

  public appropriateUsePolicyContent: string = '';

  constructor(public activeModal: NgbActiveModal, private service: ChangePasswordService, private toastr: ToastrService) { }

  public editForm: UntypedFormGroup = new UntypedFormGroup({
    proposedPassword: new UntypedFormControl(null, [Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$*.{}?"!@#%&/,><\':;|_~`^\\]\\[\\)\\(]).{1,}')]),
    confirmPassword: new UntypedFormControl(null),
  }, this.pwdMatchValidator);

  ngOnInit() {
  }

  pwdMatchValidator(frm: UntypedFormGroup) {
    return frm.get('proposedPassword').value === frm.get('confirmPassword').value
      ? null : { 'mismatch': true };
  }

  public changeInitialPassword() {
    this.service.changeInitialPassword(this.editForm.value).subscribe(data => {
      this.activeModal.close('Agree');
      //this.toastr.success('Password changed', 'Change Password', { closeButton: true });
    }, error => {
      console.log(error);
      this.toastr.error('Error changing password', 'Change Password', { closeButton: true });

    })
  }

}
